import { useMutation } from "@tanstack/react-query";
import { saveKlaviyoMappings } from "../../api/bKlaviyoApi";

export const useSaveKlaviyoMappings = () => {
  return useMutation({
    mutationKey: ["save-klaviyo-mappings"],
    mutationFn: (data) => saveKlaviyoMappings(data),
    onError: (error) => {
      console.error("Klaviyo mapping save error:", error.response || error);
    },
  });
};
